import { Dot } from "@tamagui/lucide-icons";
import { GetProps, XStack, YStack } from "tamagui";

import { Text } from "./Typography";

type ListItem =
  | {
      label: string;
      childListItems?: ListItem[];
    }
  | string;

const List = ({
  listItems,
  level = 0,
  color = "$textSecondary",
  textProps,
  listProps,
}: {
  listItems: ListItem[];
  level?: number;
  color?: string;
  textProps?: GetProps<typeof Text>;
  listProps?: GetProps<typeof YStack>;
}) => {
  return (
    <YStack
      role="list"
      marginLeft={level > 0 ? "$200" : 0}
      paddingTop={level > 0 ? "$100" : 0}
      gap="$100"
      {...listProps}
    >
      {listItems.map((item) => {
        const text = typeof item === "string" ? item : item.label;
        return (
          <YStack key={text} role="listitem">
            <XStack
              justifyContent="flex-start"
              alignItems="flex-start"
              gap="$100"
            >
              <Dot color={color} size={19} flexGrow={0} flexShrink={0} />
              <Text color={color} {...textProps}>
                {text}
              </Text>
            </XStack>
            {typeof item === "object" && item.childListItems && (
              <List
                color={color}
                listItems={item.childListItems}
                level={level + 1}
                listProps={listProps}
              />
            )}
          </YStack>
        );
      })}
    </YStack>
  );
};

export default List;
